function initAccordeon() {
  const accordeonButton = document.querySelector(".js-button");
  //accordeonButton.setAttribute("disabled", "true");
  //accordeonButton.setAttribute("aria-disabled", "true");

  try {
      // Écouter l'événement dataReady de IndexedDBManager pour s'assurer que les données sont complètement chargées
      if (window.IndexedDBManager) {
        window.IndexedDBManager.addEventListener("dataReady", (eventData) => {
          // Mettre une animation de chargement ici si nécessaire
          //
          //console.log("AccordéonFilters: données prêtes avec source =", eventData.source);

          // Activer le bouton seulement si les données sont prêtes et sans erreur
         /* if (eventData.source !== "error") {
            accordeonButton.removeAttribute("disabled");
            accordeonButton.removeAttribute("aria-disabled");
          }*/
        });
      } else {
          // Si IndexedDBManager n'est pas encore disponible, réessayer
          setTimeout(initAccordeon, 100);
      }
    } catch (error) {
       console.error("Erreur Accordéon:", error);
    }
}

window.initAccordeon = initAccordeon;
export default initAccordeon;
